import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import Section from "../components/Section";
import WhiteGradientButton from "../components/WhiteGradientButton";
import vdo from "../images/NewUI/effect.mp4";
import heroLogo from "../images/NewUI/hero_logo.png";

const HeroSectionStyle = styled(Section)`
  position: relative;

  video {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, 0);
    object-fit: cover;
    width: 200%;

    @media (min-width: 600px) {
      top: 0;
    }
    @media (min-width: 970px) {
      top: -33%;
    }
    @media (min-width: 1200px) {
      width: 150%;
    }
    @media (min-width: 1536px) {
      top: -20%;
      width: 100%;
    }
  }
`;

const HeroSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <HeroSectionStyle
      className="d-flex align-center"
      sx={{ minHeight: "75vh" }}
    >
      <video loop muted autoPlay playsInline src={vdo} />

      <div
        style={{ position: "relative", zIndex: 1 }}
        className={`d-flex flex-column ${md ? "" : "align-center"}`}
      >
        <img
          src={heroLogo}
          alt=""
          width={lg ? "50%" : md ? "60%" : sm ? "80%" : "100%"}
        />
        <WhiteGradientButton
          className={`d-flex align-center justify-center`}
          sx={{ width: "fit-content", mt: md ? "-48px" : 4 }}
          href="https://zeeg.me/sixnetwork"
          target="_blank"
        >
          CONTACT US
        </WhiteGradientButton>
      </div>
    </HeroSectionStyle>
  );
};

export default HeroSection;
